import React, { useState } from 'react';
import Sidebar from '../../components/ui/Sidebar';
import BreadcrumbNavigation from '../../components/ui/BreadcrumbNavigation';
import BookingTabNavigation from './components/BookingTabNavigation';
import ReceiptReviewQueue from './components/ReceiptReviewQueue';
import PendingBookings from './components/PendingBookings';
import TodayBookings from './components/TodayBookings';
import { getSelectedSalonId } from 'utils/salon';
import EmployeeBookings from './components/EmployeeBookings';

const BookingManagement = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // شناسه سالن به صورت پیش‌فرض یا از لوکال استوریج خوانده می‌شود
  const [selectedSalon] = useState(getSelectedSalonId);

  const [activeTab, setActiveTab] = useState('receipts');
  const isEmployee = (() => { try { return JSON.parse(atob(localStorage.getItem('token')?.split('.')[1] || ''))?.role === 'employee'; } catch { return false; } })();

  const renderTabContent = () => {
    switch (activeTab) {
      case 'receipts':
        return <ReceiptReviewQueue salonId={selectedSalon} />;
      case 'pending':
        return <PendingBookings salonId={selectedSalon} />;
      case 'today':
        return <TodayBookings salonId={selectedSalon} />;
      default:
        return <ReceiptReviewQueue salonId={selectedSalon} />;
    }
  };

  return (
    <div className="min-h-screen bg-background" dir="rtl">
      {/* Sidebar - Desktop is fixed, Mobile uses sidebarOpen state */}
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <main className="lg:mr-60 pt-16 lg:pt-6">
        <div className="p-6 space-y-6">
          {/* Breadcrumbs */}
          <BreadcrumbNavigation />

          {isEmployee ? <EmployeeBookings salonId={selectedSalon} /> : <>
          {/* Page Title */}
          <div>
            <h1 className="text-2xl font-bold text-foreground mb-1">
              مدیریت رزروها و نوبت‌ها
            </h1>
            <p className="text-sm text-muted-foreground">
              تایید و رد تراکنش‌ها و نوبت‌های سالن به همراه آمار امروز سالن
            </p>
          </div>

          {/* Navigation Tabs */}
          <div className="border-b border-border pb-4">
            <BookingTabNavigation activeTab={activeTab} onTabChange={setActiveTab} />
          </div>

          {/* Tab Content Rendering */}
          <div className="min-h-[400px]">
            {renderTabContent()}
          </div>
          </>}
        </div>
      </main>
    </div>
  );
};

export default BookingManagement;
export { BookingManagement };
